import { features } from '@/mocks/features';

export default function FeatureGrid() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-semibold bg-primary-100 text-primary-700 rounded-full mb-4">
            Core Features
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3 font-heading">
            Smart Product Intelligence System
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            We transform raw product data into structured spreadsheets that empower smarter purchasing decisions
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feature, i) => (
            <div
              key={i}
              className="group p-6 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 mb-4 group-hover:bg-accent-200 transition-colors">
                <i className={`${feature.icon} text-xl text-accent-600`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2 font-heading">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}